/**
 * Shopping Centers Image URLs
 * Simple mapping of location names to image URLs
 */
export const SHOPPING_CENTER_IMAGES: Record<string, string> = {
  'Pitt Street Mall': 'https://images.unsplash.com/photo-1723151637928-13f3047a9fb2?q=80&w=1035&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'Westfield Sydney': 'https://images.unsplash.com/photo-1728207278618-6121e1d63b65?q=80&w=988&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'The Strand Arcade': 'https://upload.wikimedia.org/wikipedia/commons/7/7b/The_Strand_Arcade_interior_photographed_from_the_top_level%2C_Sydney_02.jpg',
  'Queen Victoria Building': 'https://images.pexels.com/photos/3861588/pexels-photo-3861588.jpeg',
  '25 Martin Place': 'https://www.sl.nsw.gov.au/sites/default/files/styles/max_width_1500/https/s3-ap-southeast-2.amazonaws.com/prod--slnsw-corporate-site/uploads/2018-06/collection-items/40541/a3615002r.jpg?itok=JvXuvkXQ',
};

/**
 * Get image URL for a shopping center by location name
 * Supports exact match, case-insensitive match, and partial matching
 */
export const getShoppingCenterImageUrl = (locationName: string): string | null => {
  if (!locationName) return null;
  
  // Try exact match first
  if (SHOPPING_CENTER_IMAGES[locationName]) {
    return SHOPPING_CENTER_IMAGES[locationName];
  }
  
  // Try case-insensitive match
  const lowerName = locationName.toLowerCase();
  const exactMatch = Object.keys(SHOPPING_CENTER_IMAGES).find(
    key => key.toLowerCase() === lowerName
  );
  if (exactMatch) {
    return SHOPPING_CENTER_IMAGES[exactMatch];
  }
  
  // Try partial match (e.g., "Westfield" in "Westfield Sydney")
  const partialMatch = Object.keys(SHOPPING_CENTER_IMAGES).find(
    key => lowerName.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerName)
  );
  
  return partialMatch ? SHOPPING_CENTER_IMAGES[partialMatch] : null;
};
